export * from 'SourceComponent/ProductActions/ProductActions.config';

export const ACTIONS_SCROLL_DEBOUNCE_DELAY = 10;
export const ACTIONS_SCROLL_BOTTOM_TRESHOLD = 60;
export const STICKY_ACTIONS_OFFSET = 140;
